$('#add_to_cart_btn_id').click(function(evt){    
  var temp_variant_id = jQuery(this).attr('data-id');
  var temp_qty = jQuery('#product_quickview_id .QuantityInput').val();
  //wc_theme_source.lib.addtocart_product(temp_variant_id, temp_qty);
  
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: temp_qty,
      id: temp_variant_id
    },
    dataType: 'json', 
    success: function (data) { 
      //alert('Yes');
      jQuery('#added_product_popup').find('h3').html('<strong>'+ item.title + '</strong> <span>added to your Cart</span>');
      setTimeout(function(){ jQuery.getJSON('/cart.js', function(cart) { $('#CartCount').html(cart.item_count); }); }, 2000);
      //$('#close_quickview_popup').trigger( "click" );
      //$('body').addClass('CartOpen');                  
      //$('#close_quickview_popup').trigger( "click" );
      //$("#cart_modal_popup").modal('show'); 

    } 
  });
  
  return false;
});





$('#add_to_cart_btn_id').click(function(evt) {
  Shopify.addItemFromForm($(this).closest('form').attr('id'), $(this).attr('id'));
  return false;
});

Shopify.addItemFromForm = function(form_id, variant_id, callback) {
  $('.quickview_added_product_cls').hide();
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    beforeSend: function(){
      if(form_id == "add_to_cart_form") {
        jQuery('#'+form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
      }
    },
    data: jQuery('#' + form_id).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
        setTimeout(function(){
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
        }, 2000);
        $('.quickview_added_product_cls').show('300');
        setTimeout(function(){ jQuery.getJSON('/cart.js', function(cart) { $('#CartCount').html(cart.item_count); }); }, 2000);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if(form_id != "add_to_cart_form") {
        Shopify.onError(XMLHttpRequest, textStatus);
      } else {
        jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_error").html());
        setTimeout(function(){
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
        }, 2000);
      }
    }
  };
  jQuery.ajax(params);
};
var mainImage = '';
var shop_url = $('#shop_url_id').text();
var shop_money_format = $('#shop_currency_val').text();
function changePriceValue(cell, value){
  var qv_price_html = '<span class="money">'+Shopify.formatMoney(value, shop_money_format)+'</span>'
  jQuery(cell).html(qv_price_html);
};

jQuery(function ($){
  $(document).on('change', '#product-select-wc', function(){
    var th_selected_val = $(this).find('option:selected');
    var th_vari_price = th_selected_val.data('price');
    var th_vari_compare_price = th_selected_val.data('compare-price');
    var th_vari_sku = th_selected_val.data('sku');
    var th_vari_available = th_selected_val.data('available');
    var th_vari_image = th_selected_val.data('image');
    var th_vari_id = th_selected_val.val();

    $('#product_quickview_id .quickview_add_to_cart_btn').attr('data-id',th_vari_id);
    changePriceValue('.price-box .quick_main_price', parseFloat(th_vari_price));
    if(parseFloat(th_vari_compare_price) > parseFloat(th_vari_price)){
      changePriceValue('.price-box .quick_compare_price', parseFloat(th_vari_compare_price));
      $('.price-box .quick_compare_price').show();
    } else{
      $('.price-box .quick_compare_price').hide();
    }

    if(th_vari_sku != '' && th_vari_sku != null){
      $('.quickview_product_desc_cls .pro_sku .product_sku_cls').text(th_vari_sku);
      $('.quickview_product_desc_cls .pro_sku').show();
    } else{
      $('.quickview_product_desc_cls .pro_sku').hide();
    }   
    $("ul.quickview_poplet_img_ul li").each(function(index){
      var temp_img_src = $(this).data('img');        
      if('https:'+temp_img_src == th_vari_image){
        $(this).find('.product_poplet_imgs').trigger("click");
      }
    });    
    if(th_vari_available == 'true' || th_vari_available){
      $('.quickview_product_desc_cls .pro_stock .on_stock').removeClass('off_stock');
      $('.quickview_product_desc_cls .pro_stock .on_stock').text('In stock');
      $('.quickview_add_to_cart_btn').prop('disabled', false);
    } else{
      $('.quickview_product_desc_cls .pro_stock .on_stock').text('Out of stock');
      $('.quickview_product_desc_cls .pro_stock .on_stock').addClass('off_stock');
      $('.quickview_add_to_cart_btn').prop('disabled', true);
    }
  });
  $(document).on('change', '.th_quick_swatch_input', function(){
    var th_selected_val = new Array();
    $('.th_variants_div').each(function(index){
      var input_selected_val = $(this).find('.th_quick_swatch_input:checked').val();
      th_selected_val.push(input_selected_val);
      if(index === $('.th_variants_div').length - 1){
        var final_selected_Val =  th_selected_val.join(" / ");
        $('#product-select-wc').prop('selected', false);
        $('#product-select-wc option[data-title="'+final_selected_Val+'"]').prop('selected', true).trigger('change');
      }
    });
  });
  
  Shopify.onProduct = function(product){
    $('.quickview_fullinfo').attr('href', product.url);
    var _parent = '#product_quickview_id';
    $(_parent+' .product_title a').text(product.title);
    if( product.variants.length == 1 ){
      $(_parent+' .pro_sku').show();
      $(_parent+' .pro_sku .product_sku_cls').text(product.variants[0].sku);   
      $(_parent+' .pro_stock .on_stock').text();
      var pro_av = product.available ;
      if(pro_av == 'true' || pro_av){
        $('.quickview_product_desc_cls .pro_stock .on_stock').removeClass('off_stock');
        $('.quickview_product_desc_cls .pro_stock .on_stock').text('In stock');
        $('.quickview_add_to_cart_btn').prop('disabled', false);
      } else{
        $('.quickview_product_desc_cls .pro_stock .on_stock').text('Out of stock');
        $('.quickview_product_desc_cls .pro_stock .on_stock').addClass('off_stock');
        $('.quickview_add_to_cart_btn').prop('disabled', true);
      }
    }
    $(_parent+' .product_title a').attr('href', product.url);
    $(_parent+' .quickview_social_sharing .facebook_share_url').attr('href', '//www.facebook.com/sharer.php?u='+shop_url+product.url);
    $(_parent+' .quickview_social_sharing .twitter_share_url').attr('href', '//twitter.com/share?text='+product.title+'&amp;url='+shop_url+product.url);
    $(_parent+' .quickview_social_sharing .pinterest_share_url').attr('href', '//pinterest.com/pin/create/button/?url='+shop_url+product.url+'&amp;media='+product.featured_image+'&amp;description='+product.featured_image);
    $(_parent+' .quickview_social_sharing .google_share_url').attr('href', '//plus.google.com/share?url='+shop_url+product.url);

    
    var variant = '';
    for (i = 0; i < product.variants.length; i++){
      if(product.variants[i].inventory_quantity > 0){
        variant = product.variants[i];
        break;
      }
    }
    if(variant){
      for (i = 0; i < product.variants.length; i++){
        if(product.variants[i].inventory_policy == "continue"){
          variant = product.variants[i];
          break;
        }
      }
    } else{
      variant = product.variants[0];
    }
    mainImage = product.featured_image;
    var shopifyimgurl = variant.featured_image ? variant.featured_image.src : product.featured_image;
    var imgurl = "<img class=\"full-width img-fluid mx-auto\" id=\"quickview_img_zoom\" alt=\"\" src = \""+Shopify.resizeImage(shopifyimgurl, 'large')+"\">";
    jQuery(_parent+' .quickview_large_img_ul .product_main_img_cls').empty();
    jQuery(_parent+' .quickview_large_img_ul .product_main_img_cls').append(imgurl);
    var poplet_imgs = '';
    if(product.images.length > 1){
      for (i = 0; i < product.images.length; i++){
        var temp_img = product.images[i];
        var temp_img_alt = product.images[i];
        poplet_imgs += '<li class="col-12 cless" data-img="'+temp_img_alt+'"><figure class="product_poplet_imgs"><img class="img-fluid mx-auto" src="'+Shopify.resizeImage(temp_img, 'large')+'"></figure></li>';
      }
    }
    if(product.variants.length > 1){
      var variants_item = '';
      $.each(product.options, function(option_key, option_val){
        var pro_name_lower = option_val.name.toLowerCase();
        var pro_name_handle = option_val.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        if (option_val.name != 'down'){
          variants_item += '<div class="th_variants_div"><h5>' + option_val.name + '</h5><ul class="pro_' + pro_name_handle + '">';
          $.each(option_val.values, function (vari_key, vari_val) {
            var pro_item_handle = vari_val.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
            var pvo_style = (pro_name_lower == "color" || pro_name_lower == "colour") ? 'style="background-color:' + vari_val + '"' : '';
            var pvo_value = (pro_name_lower != "color" && pro_name_lower != "colour") ? vari_val : '';
            var pvo_selected = (vari_key === 0) ? 'checked' : '';
            variants_item += '<li data-value="' + pro_item_handle + '" class="swatch-element ' + pro_item_handle + '"><input id="swatch-' + pro_item_handle + '" class="th_quick_swatch_input" type="radio" name="option-' + pro_name_handle + '" value="' + vari_val + '" ' + pvo_selected + '><label for="swatch-' + pro_item_handle + '" data-swatch-title="' + pro_item_handle + '" class="' + pro_item_handle + '"' + pvo_style + '>' + pvo_value + '</label></li>';
          });
          variants_item += '</ul></div>';
        }
        
      });
    }
    $('#add_to_cart_form .swatch').html(variants_item);
    var total_pop_imgs = '';
    total_pop_imgs = poplet_imgs;
    jQuery(_parent+' .slider-nav.poplet').empty();
    jQuery(_parent+' .slider-nav.poplet').append(total_pop_imgs);
    var desc = product.description;
    var split_desc = desc.split('<!--split-->')[0];
    $(_parent+' .product-info__description').show();
    $(_parent+' .product-info__description').html(split_desc);
    var pro_vendor = product.vendor;
    $(_parent+' li.pro_vendor span').html(pro_vendor);
    var inv_qua = variant.inventory_quantity;
    if(variant.price < variant.compare_at_price){
      changePriceValue('.price-part .quick_compare_price', variant.compare_at_price);
      changePriceValue('.price-part .quick_main_price', variant.price);
    } else{
      $('.price-part .quick_compare_price').hide();
      changePriceValue('.price-part .quick_main_price', variant.price);
    }            
    if(product.variants.length > 1){
      var variants_margin = product.options.length == 2 ? 'variants_margin' : '';
      var select = '<select id="product-select-wc" name="id">';
      var selected = 'selected';
      for (i = 0; i < product.variants.length; i++){        
        var _var = product.variants[i];
        //console.log(_var);
        if( _var.featured_image == null ){
          var variant_img = 'https:'+mainImage; 
        }else{
          var variant_img = _var.featured_image.src;
        }        
        var pro_available = _var.available ? 'true' : 'false';
        select += '<option value="'+_var.id+'"'+selected+' data-sku="'+_var.sku+'" data-title="'+_var.title+'" data-image="'+variant_img+'" data-compare-price="'+_var.compare_at_price+'" data-price="'+_var.price+'" data-available="'+pro_available+'">'+_var.title+'</option>'
        selected = '';
      }
      select += '</select>';
      var variant_select = '<div class="variants_selects ' + variants_margin + '">';
      variant_select += select;
      variant_select += '</div><div class="divider divider--sm"></div>';
      select = variant_select;
    } else{
      var select = '<input type="hidden" name="id" value="' + product.variants[0].id + '" />';
      $('#product_quickview_id .quickview_add_to_cart_btn').attr('data-id',product.variants[0].id);
    }
    $('.variants').empty();
    $('.variants').html(select);
    if(product.available && product.variants.length > 1){} else{
      jQuery('.currency .active').trigger('click');
    }
    if($(".spr-badge").length > 0){
      $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
    }
    if($(".selector-wrapper label").length){
      $(".selector-wrapper label").each(function(index){
        $(this).text(jQuery(this).text());
      });
    }
    var main_img_url = Shopify.resizeImage(shopifyimgurl, 'large');
    $('#quickview_img_zoom').attr('src', main_img_url).on('load', function(){
      $('.quickview_outer_padding_cls').removeClass('animated fadeIn');
    });
    $('.loader_img_cls').hide();
    $('#product_quickview_id .quickview_grid').show();
    $('#product-select-wc').trigger('change');
    setTimeout(function(){
      jQuery('.slider-nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        focusOnSelect: true,
        infinite: true,
        arrows: false,
        responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        }
      ]      
      });      
      $('#product_quickview_id .product_poplet_imgs').on('click', function (e) {
        var img_url = $(this).find('img').attr('src');
        $('.quickview_large_img_ul').find('figure img').attr('src', img_url);
      });
    }, 500);
    if(!( 'ontouchstart' in window) && !navigator.msMaxTouchPoints && !navigator.userAgent.toLowerCase().match( /windows phone os 7/i ) ) return false;
  }
  open_quickview = function(product_handle){
    $('#product_quickview_id').show();
    $('.quickview_outer_padding_cls').addClass('animated fadeIn');
    $('body').addClass('overflow_fixed');
    $('#product_quickview_id .quickview_grid').hide();
    $('.loader_img_cls').show();
    console.log(product_handle);
    Shopify.getProduct(product_handle);
  }
});
$('#close_quickview_popup').click(function(){
  var _parent = '#product_quickview_id';
  $('.custome_modal_start').addClass('animated fadeOut');
  setTimeout(function(){
    $('body').removeClass('overflow_fixed');
    $('.quickview_added_product_cls').hide();
    jQuery(_parent+' .quickview_large_img_ul .product_main_img_cls').empty();
    jQuery(_parent+' .slider-nav.poplet').empty();
    $(_parent+' .product_title a').text('');
    $(_parent+' .product_title a').attr('href', '');
    $('.price-part .main').empty();
    $('.price-part .price-box__new').empty();
    $(_parent+' .product-info__description').empty();
    $(_parent+' .swatch').empty();
    $(_parent+' .pro_sku .product_sku_cls').empty();
    $(_parent+' .pro_vendor span').empty();
    $(_parent+' .pro_stock .on_stock').removeClass('off_stock').empty();
    $(_parent+' .variants').empty();
    $(_parent+' .product-disable').hide();
    $('.custome_modal_start').removeClass('animated fadeOut');
    $('#product_quickview_id').hide();
    $('.zoomContainer').remove();
    $('.responseJSON_Error h5').empty();
    $('.responseJSON_Error').hide();

    jQuery('.slider-nav').slick('unslick');
  }, 100);
});

